var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site-settings"},[_c('b-card',[[_c('form-generator',{attrs:{"elements":_vm.elements,"data":_vm.data,"handleUpdate":_vm.handleUpdate}}),_c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.updated_html)}})])]],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }